"use client"

import { useEffect } from "react"
import { useSession } from "next-auth/react"

// Преобразование VAPID ключа
function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/")
  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

export function ServiceWorkerRegister() {
  const { data: session } = useSession()

  useEffect(() => {
    if (typeof window !== "undefined" && "serviceWorker" in navigator && "Notification" in window) {
      navigator.serviceWorker
        .register("/sw.js")
        .then(async (registration) => {
          // Если пользователь авторизован и разрешение уже выдано — подписываемся
          if (session?.user && Notification.permission === "granted") {
            subscribeToPush(registration)
          }
          // Если разрешение "default" — ждём явного запроса пользователем
          // через кнопку в PaymentAlertToast или настройках профиля
        })
        .catch((error) => {
          console.error("[App] Service Worker registration failed:", error)
        })
    }
  }, [session])

  // Функция подписки на push
  async function subscribeToPush(registration: ServiceWorkerRegistration) {
    try {
      // Получаем публичный VAPID ключ с сервера (актуальный)
      const vapidRes = await fetch("/api/notifications/push")
      const { publicKey } = await vapidRes.json()
      
      if (!publicKey) {
        console.warn("[App] VAPID public key not available from server")
        return
      }

      // Если подписка уже существует — только синхронизируем с сервером (upsert).
      // НЕ пересоздаём: это сбросило бы isEnabled=false, выставленный пользователем.
      const existingSubscription = await registration.pushManager.getSubscription()
      if (existingSubscription) {
        await saveSubscriptionToServer(existingSubscription)
        return
      }

      // Подписки нет — создаём новую
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey) as BufferSource
      })

      await saveSubscriptionToServer(subscription)
    } catch (error) {
      console.error("[App] Error subscribing to push:", error)
    }
  }

  // Сохранение подписки на сервере
  async function saveSubscriptionToServer(subscription: PushSubscription) {
    try {
      const res = await fetch("/api/notifications/push", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ subscription: subscription.toJSON() })
      })
      
      if (res.ok) {
        console.log("[App] Push subscription saved to server")
      } else {
        console.error("[App] Failed to save push subscription")
      }
    } catch (error) {
      console.error("[App] Error saving push subscription:", error)
    }
  }

  return null
}
















